import { useGetQuestionsProductMutation } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import QuestionItem from '@/entities/questions-page/QuestionItem/index.js'
import QuestionForm from '@/features/questions-page/Form/index.js'

export const FaqChapter = ({ productId, productName }) => {
    const [getFaq] = useGetQuestionsProductMutation(productId)
    const [questions, setQuestions] = useState([])
    const [countShowQuestions, setCountShowQuestions] = useState(5)

    const limitQuestions = countShowQuestions >= questions.length

    useEffect(() => {
        getFaq(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setQuestions(Object.values(res.data))
                } else if (!res.data.length) {
                    setQuestions([])
                }
            })
            .catch(() => TOAST_ERROR('Не удалось получить вопросы'))
    }, [])

    if (!questions) {
        return <h4>Загрузка...</h4>
    }

    return (
        <div className={'FaqChapter'}>
            <QuestionForm order={{ name: productName, id: productId }} />
            <div className={'questions'}>
                {questions
                    ?.reverse()
                    .slice(0, countShowQuestions)
                    .map((question, index) => (
                        <QuestionItem key={index} {...question} />
                    ))}
                {!questions.length && (
                    <div>По данному товару нет вопросов.</div>
                )}
                {!limitQuestions && (
                    <div className={'action'}>
                        <button
                            onClick={() =>
                                setCountShowQuestions((state) => state + 5)
                            }
                        >
                            <img
                                src="/icons/showMore.svg"
                                alt="Иконка загрузки новых вопросов"
                            />
                            <span>Показать ещё</span>
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
